import { render } from "./SideBar.html?vue&type=template&id=7b152880&scoped=true&external"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.scss?vue&type=style&index=0&id=7b152880&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b152880"]])

export default __exports__